var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"bdc-help-icon",class:_vm.iconClass,style:(_vm.iconStyle),attrs:{"src":_vm.iconSrc,"alt":"","aria-hidden":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }